import React from 'react';
import {  Show,
ShowButton,List,EditButton,SimpleForm,
 Datagrid,RichTextInput,DisabledInput,TextInput,Edit,
TextField, RichTextField ,SimpleShowLayout,TabbedForm,FormTab,Create
 }
from 'admin-on-rest/lib/mui';

export const TerminalTypesList = (props) => (
    <List title="סוגי מסופים" {...props}>
        <Datagrid>
            <TextField label="#" source="id" />
             <TextField label="שם" source="name" />
             <TextField  label="סוג" source="type" />
   <EditButton />
            <ShowButton />
        </Datagrid>
    </List>
);

const TerminalTypesTitle = ({ record }) => {
    return <span>TerminalTypes {record ? `"${record.bank}"` : ''}</span>;
};


export const TerminalTypesShow = (props) => (

<Show title={<TerminalTypesTitle />} {...props}>
 <SimpleShowLayout>
        <TextField label="#" source="id" />
        <TextField label="שם" source="name" />
        <TextField label="סוג" source="type" />

         </SimpleShowLayout>
    </Show>
);


export const TerminalTypesEdit = (props) => (
    <Edit {...props}>

        <SimpleForm>
 <DisabledInput source="id" />
<TextInput  source="name" />
<TextInput  source="type" />
        </SimpleForm>
  </Edit>
);

export const TerminalTypesCreate = (props) => (
    <Create title="הוספת סוג מסוף חדש" {...props}>
      <SimpleForm >

              <DisabledInput label="Id" source="id" />
                <TextInput source="name" label="שם"/>
                <TextInput source="type" label="סוג" />





      </SimpleForm>
    </Create>
);



// WEBPACK FOOTER //
// ./src/components/TerminalTypes/terminaltypes.js